import { takeLatest, put, call } from 'redux-saga/effects';

import { fetchCompaniesSuccess, fetchCompaniesFail } from '../actions';
import { coreAPI } from 'utils/request';
import { FETCH_COMPANIES } from '../constants';
import NProgress from 'nprogress';
import { showErrorNotification } from '@aha/utils';

function* doFetch({ hid }) {
  yield call(NProgress.start);
  try {
    const { data } = yield call(coreAPI.get, `v1/pms/companies`);
    yield put(fetchCompaniesSuccess(data));
  } catch (err) {
    showErrorNotification('Fail to fetch', err);
    yield put(fetchCompaniesFail(err));
  }
  yield call(NProgress.done);
}

export function* watchFetchConpanies() {
  yield takeLatest(FETCH_COMPANIES, doFetch);
}
